import { createContext } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { InputFormValuesEdit } from './types'

export interface CombinedLogsContext {
    form?: UseFormReturn<InputFormValuesEdit, void, InputFormValuesEdit>
    setIsCreateFormActive: (isActive: boolean) => void
}

export const Context = createContext<CombinedLogsContext>({
    setIsCreateFormActive: () => {},
})
